import styled from 'styled-components';
import { zIndex } from 'tokens';

export const LoaderWrapper = styled.div`
	width: 32px;
	height: 32px;
`;

export const SidebarToggleWrapper = styled.div`
	position: absolute;
	top: 10px;
	left: 10px;
	z-index: ${zIndex.loading};
`;
